// extracted by mini-css-extract-plugin
export default {"imageWrapper":"wC-z","videoWrapper":"xC-z","twoColumnImage":"yC-z","imageCarouselBtn":"zC-z","carouselNextBtn":"AC-z","carouselPrevBtn":"BC-z"};